// components/ArticleCard.jsx

import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const ArticleCard = ({ article, onClick }) => {
    const navigate = useNavigate();

    const safeHandleClick = useCallback(() => {
        if (onClick) {
            onClick(article.path);
        } else {
            navigate(`/articles/${article.path}`);
        }
    }, [article.path, onClick, navigate]);

    return (
        <div
            className="article-card w-full h-full"
        >
            <div 
                className="card h-full cursor-pointer rounded-xl overflow-hidden bg-card-light dark:bg-card-dark duration-300 ease-in-out"
            >
                
                {/* Image Container */}
                <div className="card-img-container h-[200px] overflow-hidden">
                    <img
                        src={article.imageUrl || '/images/default-articles.webp'}
                        alt={article.title}
                        // Removed onMouseEnter/onMouseLeave for image. Card hover handles the effect.
                        className="card-img w-full h-full object-cover transition-transform duration-500 ease-in-out hover:scale-[1.05]"
                        loading="lazy"
                        style={{ 
                            objectPosition: `center ${
                                typeof article.imageOffsetY === 'number'
                                    ? `${article.imageOffsetY}%`
                                    : article.imageOffsetY || '50%'
                            }`,
                            // Removed the transition style as it's already in the className
                        }}
                    />
                </div>

                {/* Card Body */}
                <div className="card-body p-4 flex flex-col h-full">
                    
                    <div className="flex justify-between items-center mb-1">
                        <span className="badge badge-primary dark:badge-secondary inline-flex items-center px-3 py-1 text-xs font-medium rounded-full bg-primary/10 text-primary dark:bg-secondary/10 dark:text-secondary">
                            {article.category}
                        </span>
                    </div>

                    {/* Title */}
                    <h5 className="card-title text-lg font-semibold mb-2 text-text-light dark:text-text-dark line-clamp-2">
                        {article.title}
                    </h5>

                    {/* Text */}
                    <p className="card-text text-sm mb-3 text-muted-light dark:text-muted-dark line-clamp-3 min-h-[3rem] flex-1">
                        {article.short_text}
                    </p>

                    {/* Footer */}
                    <div className="flex justify-between items-center pt-3 mt-auto border-t border-border-light dark:border-border-dark">
                        <small className="text-muted-light dark:text-muted-dark text-xs">
                            {article.date}
                        </small>
                        
                        <button
                            onClick={e => {
                                e.stopPropagation();
                                safeHandleClick();
                            }}
                            className="text-sm font-medium text-primary dark:text-secondary hover:underline transition-colors"
                        >
                            Read Article &rarr;
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ArticleCard);